import React from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils";
import { TableCell, TableRow } from "../table";

export interface TableLoadingStateProps {
  colSpan: number;
  label?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  cellClassName?: string;
  showSpinner?: boolean;
}

export function TableLoadingState({
  colSpan,
  label,
  description,
  className,
  cellClassName,
  showSpinner = true,
}: TableLoadingStateProps) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t("ui.loading");
  const resolvedDescription = description ?? t("ui.please_wait_fetching_data");

  return (
    <TableRow className={cn("border-b-0 hover:bg-transparent", className)}>
      <TableCell colSpan={colSpan} className={cn("px-0 py-10", cellClassName)}>
        <div className="flex min-h-[220px] w-full items-center justify-center px-4">
          <div className="flex w-full max-w-none flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-8 text-center shadow-sm dark:border-gray-800 dark:bg-gray-950">
            {showSpinner && (
              <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
                <Loader2 className="h-6 w-6 animate-spin text-gray-500 dark:text-gray-300" />
              </div>
            )}
            <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
              {resolvedLabel}
            </div>
            <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {resolvedDescription}
            </div>
          </div>
        </div>
      </TableCell>
    </TableRow>
  );
}
